import { UPDATE_DIR_DATA } from './constants'
import { IUPDATE_DIR_DATA } from './validations';

export const updateDirectoryData = (actionData: IUPDATE_DIR_DATA['actionData']): IUPDATE_DIR_DATA => {
  return {
    type: UPDATE_DIR_DATA,
    actionData,
  };
}
